import '!style-loader!css-loader!video.js/dist/video-js.css';
import videojs from 'video.js';
import env from 'src/env'; 
import platform from 'platform';
import 'dashjs';
import 'videojs-contrib-dash';

const playTracking = (eventParams) => {
  eventParams['authenticity_token'] = document.getElementsByName('csrf-token')[0].
                                               getAttribute('content');

  fetch('/analytics/view', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(eventParams)
  });
}; 

const determinePlayerSource = (hls, dash) => {
  if (platform.os.family == "iOS" || platform.name == "Safari") {  
    return hls;
  } else {
    return dash;
  }
}

const determineAspectRatio = function() {
  const windowWidth = $(window).width();
  
  if (windowWidth > 1024) {
    return "16:9"
  } else {
    return "9:16"
  }
}

const recordPlayEvents = function() {
  const dataset = this.el_.dataset;

  if (!dataset || !dataset.eventParams) {
    return;
  }

  this.one('play', () => playTracking(JSON.parse(dataset.eventParams)));
} 

videojs.registerPlugin('recordPlayEvents', recordPlayEvents);

window.initVideoJSPlayers = (options = {}) => {
  const videoEls = document.getElementsByClassName('video-js');
  const defaultOpts = Object.assign({
    controls: true,
    autoplay: false,
    preload: "none",
    playsinline: true,
    type: 'video/mp4'
  }, options);

  for (let videoEl of videoEls) {
    videojs(videoEl, defaultOpts)
  }
}

window.videojs = videojs;

const createPlayer = (video) => {
  const videoThumb = video.target.getAttribute('data-poster');
  const videoDataParams = video.target.getAttribute('data-event-params');
  const dashURL = video.target.getAttribute('data-video-dash');
  const hlsURL = video.target.getAttribute('data-video-hls');
  const mp4URL = video.target.getAttribute('data-video-mp4');

  const hlsSource = { type: 'application/x-mpegURL', src: hlsURL }

  var player = videojs(video.target, {
    controls: true,
    autoplay: false,
    preload: "metadata",
    autoSetup: false,
    oadingSpinner: true,
    textTrackSettings: false,
    playsinline: true,
    aspectRatio: determineAspectRatio(),
    fluid: true,
    techOrder: ["html5"],
    poster: videoThumb,
    html5: {
      vhs: {
        overrideNative: true,
        limitRenditionByPlayerDimensions: false,
        bandwidth: 6194304
      },
      nativeCaptions: false,
      nativeControlsForTouch: false,
      nativeAudioTracks: false,
      nativeVideoTracks: false
     }
  });

  player.ready(function() {
    player.src([
      hlsSource,
      {
        type: 'video/mp4',
        src: mp4URL
      },
    ]);
  });

  if (videoDataParams) {
    player.on('play', () => playTracking(JSON.parse(videoDataParams)));
  }

  video.target.setAttribute("data-loaded", "1");
}

window.initVideoPlayers = (options = {}) => {
  const videoElements = document.querySelectorAll('.video-player[data-loaded="0"]');
  
  var videoObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach((video) => {
      if (video.isIntersecting) {
        createPlayer(video);
        videoObserver.unobserve(video.target);
      }
    });
  });

  for (let video of videoElements) {
    videoObserver.observe(video);
  }
}

window.initVideoPlayers();
